import { Builder } from '@builder.io/react';

import ProductsImageBlock from './index';

Builder.registerComponent(ProductsImageBlock, {
  name: 'ProductsImageBlock',
  inputs: [
    { name: 'overtitle', type: 'string' },
    { name: 'title', type: 'string' },
    { name: 'subtitle', type: 'string' },
    { name: 'diagramCopy', type: 'string' }
  ]
});
